// Settings that belong to this browser only (theme, usage sharing), as the
// phone app keeps them on the device.
const PREFIX = 'paidlark.';

export function readPreference(key: string): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePreference(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(PREFIX + key);
    else localStorage.setItem(PREFIX + key, value);
  } catch {
    // Storage blocked: the choice lasts until the page closes.
  }
}
